T.FeaturedEvent = Class(
	/**
	 * @lends {T.FeaturedEvent#}
	 */
	{
		/**
		 * @param {String} type
		 * @param {DR.events.struct.Event} event
		 * @private
		 */
		__construct( type, event ) {
			this.type = type;
			this.event = event;

			this.node = mkE({
				tag: 'div',
				className: 'featured-event'
			});

			if( D.Lang.exists(`featured-event.${this.type}.title`) ) {
				mkE.appendTypeElement(this.node, [
					{
						tag: 'div',
						className: 'overline',
						text: D.Lang.get(`featured-event.${this.type}.overline`)
					},
					{
						tag: 'h2',
						className: 'h1',
						text: D.Lang.get(`featured-event.${this.type}.title`)
					}
				]);
			}

			if( this.event ) {
				this._drawEvent();
			} else {
				this._drawPlaceHolder();
			}
		},

		/**
		 * @param {DR.events.struct.Event} event
		 */
		setEvent( event ) {
			this.event = event;
			if( this._eventNode ) {
				this._eventNode.remove();
			}
			this._drawEvent();
		},

		_drawEvent() {
			const isPast = this.event.showResults;
			let date = '';
			if( this.event.settings.gameType === 'race' ) {
				if( isPast ) {
					date = D.Lang.get('events.list.gameOver');
				} else {
					date = D.Lang.get('events.list.date')
						.replace('%DATE%', D.Date.format2DateRange(this.event.startTime, this.event.endTime, D.Lang.get('events.list.date.format') + ' %H:%i', '%H:%i', ' - '));
				}
			}
			let hours = Math.ceil((this.event.endTime - this.event.startTime) / 3600);
			if( this.event.settings.gameType === 'anytime' ) {
				hours = Math.ceil(this.event.settings.gameTime / 60);
			}
			let footer = {
				tag: 'div',
				className: 'image-footer',
				els: [
					{
						tag: 'div',
						className: 'black',
						els: [
							{
								tag: 'span',
								title: D.Lang.get('events.item.time'),
								className: 'icon-box',
								els: [
									D.svgIcon('time'),
									{tag: 'span', text: hours + 'h'}
								]
							},
							this.event.stats.distance > 0 ? {
								tag: 'span',
								className: 'icon-box',
								title: D.Lang.get('events.item.distance'),
								els: [
									D.svgIcon('distance'),
									{tag: 'span', text: Math.round(this.event.stats.distance / 1000) + 'km'}
								]
							} : ''
						]
					}
				]
			};

			this._eventNode = mkE({
				tag: 'a',
				className: 'featured-event-item',
				href: D.url('/event/' + this.event.seoTitle),
				els: [
					{
						tag: 'div',
						className: 'image',
						style: {
							backgroundImage: this.event.hasImage ? 'url(' + this.event.image.large + ')' : ''
						},
						els: [
							{
								tag: 'div',
								className: 'image-top',
								els: [
									{
										tag: 'div',
										className: 'icon-box',
										title: D.Lang.get('events.filter.transportType.' + this.event.settings.transportType),
										els: [
											D.svgIcon('transport-type-' + this.event.settings.transportType)
										]
									},
									this.event.stats.pins ? {
										tag: 'div',
										className: 'icon-box pins',
										title: D.Lang.get('events.item.pins'),
										els: [
											D.svgIcon('pins'),
											{tag: 'span', text: this.event.stats.pins}
										]
									} : '',
								]
							},
							footer
						]
					},
					{
						tag: 'div',
						className: 'info',
						els: [
							{
								tag: 'div',
								className: 'header',
								els: [
									{
										tag: 'h2',
										className: 'title color-purple',
										els: [
											{
												tag: 'span',
												text: this.event.title
											}/*,
											{
												tag: 'span',
												//className: 'country cc-' + this.event.country,
												className: 'country',
												text: D.Lang.get('iso.countries.' + this.event.country)
											}*/
										]
									}
								]
							},
							this.descriptionNode = mkE({
								tag: 'div',
								className: 'description',
								els: [
									{
										tag: 'div',
										className: 'clamped',
										text: this.event.description
									}
								]
							}),
							{
								tag: 'div',
								className: 'footer',
								els: [
									{
										tag: 'div',
										className: 'date',
										text: date
									},
									{
										tag: 'span',
										className: 'button ' + (isPast ? 'button-dark-grey' : 'button-turquoise'),
										text: D.Lang.get(isPast ? 'events.list.results' : 'events.list.more')
									}
								]
							}
						]
					}
				]
			}).append(this.node);
			nl2br(this.descriptionNode);
		},

		_drawPlaceHolder() {
			this._eventNode = mkE({
				tag: 'span',
				className: 'featured-event-item placeholder',
				els: [
					{
						tag: 'div',
						className: 'image',
						els: [
							{
								tag: 'div',
								className: 'icon-type'
							}
						]
					},
					{
						tag: 'div',
						className: 'info',
						els: [
							{
								tag: 'div',
								className: 'header',
								els: [
									{
										tag: 'h2',
										className: 'title color-purple',
										els: [
											{
												tag: 'span'
											}
										]
									}
								]
							},
							{
								tag: 'div',
								className: 'description'
							}
						]
					}
				]
			}).append(this.node);
		}
	},
	mkE.Base
)